// extracted by mini-css-extract-plugin
export default {"text":"text_text__7cnWF"};